import blockHTML from './block-html';
import blockPreview from './block-preview';
import blocks from './blocks';
import blockVariationHTML from './block-variation-html';
import blockVariationPreview from './block-variation-preview';
import categories from './categories';

export default {
  blockHTML,
  blockPreview,
  blocks,
  blockVariationHTML,
  blockVariationPreview,
  categories,
};
